<template>
  <div>
    <v-fab-transition>
      <v-btn
        color="pink"
        dark
        fab
        :style="STYLE_BTN"
        @click="gerarRelatorioExcel"
      >
        <v-icon class="ml-n1">$Excel</v-icon>
      </v-btn>
    </v-fab-transition>

    <form
      :action="URL"
      method="post"
      target="_blank"
      ref="submit-form-relatorios-automatico"
    >
      <input type="text" hidden name="cabecalho" :value="JSON.stringify(cabecalho)" />
      <input type="text" hidden name="itens" :value="JSON.stringify(itens)" />
    </form>
  </div>
</template>

<script>
import $axios from '@/api/api.js';

export default {
  name: 'RelatorioExcel',
  props: {
    cabecalho: { type: Array, required: true },
    itens: { type: Array, required: true },
    topo: { type: Boolean, default: false },
    baixo: { type: Boolean, default: false },
    esquerda: { type: Boolean, default: false },
    direita: { type: Boolean, default: false },
    margem_topo: { type: [ Number, String ], default: 0 },
    margem_baixo: { type: [ Number, String ], default: 0 },
    margem_esquerda: { type: [ Number, String ], default: 0 },
    margem_direita: { type: [ Number, String ], default: 0 },
  },
  computed: {
    URL(){
      return `${$axios.defaults.baseURL}/relatorios-automatico`;
    },
    STYLE_BTN() {
      let estilo = {
        zIndex: '999',
        position: 'absolute',
        marginRight: this.margem_direita + 'px',
        marginTop: this.margem_topo + 'px',
        marginBottom: this.margem_baixo + 'px',
        marginLeft: this.margem_esquerda + 'px',
      };

      if (this.topo) estilo['top'] = 0;
      if (this.baixo) estilo['bottom'] = 0;
      if (this.esquerda) estilo['left'] = 0;
      if (this.direita) estilo['right'] = 0;

      return estilo;
    }
  },
  methods: {
    gerarRelatorioExcel() {
      this.$refs['submit-form-relatorios-automatico'].submit();
    }
  }
}
</script>
